"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSlotElement = exports.isComplexElement = exports.isNodeV2 = exports.isShellNode = exports.isAbsoluteNode = exports.isCommonNode = void 0;
const enums_1 = require("./enums");
const constants_1 = require("./constants");
const R = __importStar(require("ramda"));
const isCommonNode = (node) => Boolean(node && constants_1.COMMON_NODES.includes(node.type));
exports.isCommonNode = isCommonNode;
const isAbsoluteNode = (node) => Boolean(node && enums_1.NodeType.absolute === node.type);
exports.isAbsoluteNode = isAbsoluteNode;
const isShellNode = (node) => Boolean(node && enums_1.NodeType.shell === node.type) ||
    Boolean(node && enums_1.NodeType.node === node.type && node.elementId);
exports.isShellNode = isShellNode;
const isNodeV2 = (node) => Boolean(node && typeof node === 'object' && 'type' in node && enums_1.NodeType.node === node.type);
exports.isNodeV2 = isNodeV2;
const isComplexElement = (element) => Boolean(element && R.includes(element.type, constants_1.COMPLEX_ELEMENTS));
exports.isComplexElement = isComplexElement;
const isSlotElement = (element) => Boolean(element && R.includes(element.type, constants_1.SLOT_ELEMENTS));
exports.isSlotElement = isSlotElement;
